import Packing from './Packing';

export default Packing;
